module.exports = __webpack_public_path__ + "bb99ff90eaa7933babfd797bf6fce11a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/overalls-red-s.png
// module id = 1361
// module chunks = 0